'use es6';

import customizableStyledContent from 'raw-loader!cookie-banner/css/customizable-banner.scss';
import standardStyledContent from 'raw-loader!cookie-banner/css/standard-banner.scss';
import { addEventListener, createHtmlElement } from 'cookie-banner/utils/hspbUtils';
import { BOTTOM, TOP } from 'cookie-banner/constants/bannerTypes';
import { COOKIES_BY_CATEGORY } from 'cookie-banner/constants/privacyPolicy';
import { CATEGORY_PREFERENCES_COOKIE, CATEGORY_PREFERENCES_COOKIE_EXPIRATION, INITIAL_OPT_IN_COOKIE, INITIAL_OPT_IN_COOKIE_EXPIRATION, OPT_OUT_COOKIE, OPT_OUT_COOKIE_EXPIRATION } from 'cookie-banner/constants/trackingCookies';
import ModalTemplate from './ModalTemplate';
import { NOTIFY_BANNER_DISMISS_COOKIE, NOTIFY_BANNER_DISMISS_COOKIE_EXPIRATION } from '../constants/trackingCookies';
export const BANNER_ELEMENT_ID = 'hs-eu-cookie-confirmation';
export const TESTING_PARENT_ID = 'hs-cookie-banner-testing';
const BUTTON_GROUP_ID = 'hs-eu-cookie-confirmation-button-group';
const ACCEPT_BUTTON_ID = 'hs-eu-confirmation-button';
const DECLINE_BUTTON_ID = 'hs-eu-decline-button';
const COOKIE_SETTINGS_BUTTON_ID = 'hs-eu-cookie-settings-button';
const CLOSE_BANNER_BUTTON_ID = 'hs-eu-close-button';
const addAcceptListener = (privacySettings, privacyBannerDOMElement, privacyBanner, hideBannerFn) => {
  const {
    hideDecline
  } = privacySettings;
  const doc = privacyBanner.context.getDocument();
  const acceptButton = doc.getElementById(ACCEPT_BUTTON_ID);
  if (!acceptButton) {
    privacyBannerDOMElement.style.display = 'none';
    return;
  }
  addEventListener(acceptButton, 'click', e => {
    e.preventDefault();
    if (acceptButton.className === 'isDisabled') {
      return;
    }
    hideBannerFn();
    if (!hideDecline) {
      privacyBanner.setPrivacyConsent(true, {
        reporting: true
      });
    }
    if (privacySettings.testing) {
      return;
    }
    if (privacySettings.mode === COOKIES_BY_CATEGORY) {
      privacyBanner.cookie.set(CATEGORY_PREFERENCES_COOKIE, privacyBanner.privacyConsent.toCookieString(), {
        daysToExpire: CATEGORY_PREFERENCES_COOKIE_EXPIRATION,
        path: '/'
      });
      privacyBanner.trackAction('trackApproveCookieConsent');
    } else {
      if (hideDecline) {
        privacyBanner.cookie.set(NOTIFY_BANNER_DISMISS_COOKIE, 'true', {
          daysToExpire: NOTIFY_BANNER_DISMISS_COOKIE_EXPIRATION,
          path: '/'
        });
      } else {
        privacyBanner.cookie.set(OPT_OUT_COOKIE, 'no', {
          daysToExpire: OPT_OUT_COOKIE_EXPIRATION,
          path: '/'
        });
        privacyBanner.cookie.set(INITIAL_OPT_IN_COOKIE, 'true', {
          daysToExpire: INITIAL_OPT_IN_COOKIE_EXPIRATION,
          path: '/'
        });
        privacyBanner.trackAction('trackApproveCookieConsent');
      }
    }
  });
};
const addDeclineListener = (privacySettings, privacyBannerDOMElement, privacyBanner, hideBannerFn) => {
  const doc = privacyBanner.context.getDocument();
  if (privacySettings.hideDecline) {
    return;
  }
  const declineButton = doc.getElementById(DECLINE_BUTTON_ID);
  if (!declineButton) {
    privacyBannerDOMElement.style.display = 'none';
    return;
  }
  addEventListener(declineButton, 'click', e => {
    e.preventDefault();
    hideBannerFn();
    privacyBanner.setPrivacyConsent(false, {
      reporting: true
    });
    if (privacySettings.testing) {
      return;
    }
    if (privacySettings.mode === COOKIES_BY_CATEGORY) {
      privacyBanner.cookie.set(CATEGORY_PREFERENCES_COOKIE, privacyBanner.privacyConsent.toCookieString(), {
        daysToExpire: CATEGORY_PREFERENCES_COOKIE_EXPIRATION,
        path: '/'
      });
    } else {
      privacyBanner.cookie.set(OPT_OUT_COOKIE, 'yes', {
        daysToExpire: OPT_OUT_COOKIE_EXPIRATION,
        path: '/'
      });
      privacyBanner.cookie.remove(INITIAL_OPT_IN_COOKIE);
    }
    privacyBanner.trackAction('trackDeclineCookieConsent');
  });
};
const addCookieSettingsListener = (banner, privacySettings, bannerDOMParent, modalTemplate, hideBannerFn) => {
  if (privacySettings.mode !== COOKIES_BY_CATEGORY) {
    return;
  }
  const doc = banner.context.getDocument();
  const cookieSettingsButton = doc.getElementById(COOKIE_SETTINGS_BUTTON_ID);
  if (!cookieSettingsButton) {
    return;
  }
  addEventListener(cookieSettingsButton, 'click', e => {
    e.preventDefault();
    if (modalTemplate.hasRendered()) {
      modalTemplate.displayModal();
      return;
    }
    modalTemplate.render(bannerDOMParent, privacySettings, hideBannerFn);
  });
};
const getIsBannerPopupDisallowed = context => {
  let bannerDisallowed = false;
  const disabledPopups = context.getWindow().disabledHsPopups;
  if (!Array.isArray(disabledPopups)) {
    return bannerDisallowed;
  }
  for (let i = 0; i < disabledPopups.length; i++) {
    if (disabledPopups[i] === 'PRIVACY') {
      bannerDisallowed = true;
      break;
    }
  }
  return bannerDisallowed;
};
const getHtmlContent = (privacySettings, extraClassName) => {
  const {
    acceptWording,
    cancelWording,
    disclaimerWording,
    hideDecline,
    policyWording,
    cookiesByCategory,
    mode,
    showCloseButton
  } = privacySettings;
  const shouldDisplayCookieSettings = mode === COOKIES_BY_CATEGORY && cookiesByCategory && cookiesByCategory.cookieSettingsLabel;
  const disclaimer = disclaimerWording && !hideDecline ? `<p id="hs-eu-cookie-disclaimer">${disclaimerWording}</p>` : '';
  const acceptButton = `<a href="javascript:void(0);" id="${ACCEPT_BUTTON_ID}" role="button">
    ${acceptWording || 'Accept'}
  </a>`;
  const declineButton = !hideDecline ? `<a href="javascript:void(0);" id="${DECLINE_BUTTON_ID}" role="button">${cancelWording || "Don't ask me again"}</a>` : '';
  const cookieSettingsButton = shouldDisplayCookieSettings ? `<a href="javascript:void(0);" id="${COOKIE_SETTINGS_BUTTON_ID}" role="button">${cookiesByCategory.cookieSettingsLabel}</a>` : '';
  const closeBannerButton = showCloseButton ? `<div id="hs-eu-close-button-container"><a href="javascript:void(0);" id="${CLOSE_BANNER_BUTTON_ID}" role="button">&times;</a></div>` : '';
  return `<div id="${BANNER_ELEMENT_ID}" class="${extraClassName}" data-nosnippet>
            <div id="hs-eu-cookie-confirmation-inner">
              ${closeBannerButton}
              <div id="hs-eu-policy-wording">${policyWording}</div>
              ${disclaimer}
              <div id="hs-en-cookie-confirmation-buttons-area">
                ${cookieSettingsButton}
                <div id=${BUTTON_GROUP_ID}>
                ${acceptButton}
                ${declineButton}
                </div>
              </div>
            </div>
          </div>`;
};
const addCloseButtonListener = (privacySettings, privacyBanner, hideBannerFn) => {
  if (!privacySettings.showCloseButton) {
    return;
  }
  const doc = privacyBanner.context.getDocument();
  const closeButtonEl = doc.getElementById(CLOSE_BANNER_BUTTON_ID);
  const {
    hideDecline
  } = privacySettings;
  addEventListener(closeButtonEl, 'click', e => {
    e.preventDefault();
    hideBannerFn();
    if (privacySettings.testing) {
      return;
    }
    if (!hideDecline) {
      // opt-in & category policy
      return;
    }

    // notify policy
    privacyBanner.cookie.set(NOTIFY_BANNER_DISMISS_COOKIE, 'true', {
      daysToExpire: NOTIFY_BANNER_DISMISS_COOKIE_EXPIRATION,
      path: '/'
    });
  });
};
export default class BannerTemplate {
  constructor(privacyBanner, privacySettings) {
    this.privacyBanner = privacyBanner;
    this.privacySettings = privacySettings;
    this.modalTemplate = new ModalTemplate(this.privacyBanner);
    const {
      testing
    } = this.privacySettings;
    const {
      context
    } = this.privacyBanner;
    const doc = context.getDocument();
    const testingDOMParent = doc.getElementById(TESTING_PARENT_ID) || doc.body;
    const bannerDOMParent = testing ? testingDOMParent : doc.body;
    this.oldPadding = bannerDOMParent.style.paddingTop;
  }
  hasRendered() {
    const {
      context
    } = this.privacyBanner;
    const doc = context.getDocument();
    return doc.getElementById(BANNER_ELEMENT_ID) !== null;
  }
  getHideBannerFn() {
    return () => {
      if (!this.hasRendered()) {
        return;
      }
      const {
        context
      } = this.privacyBanner;
      const {
        bannerType,
        testing
      } = this.privacySettings;
      const doc = context.getDocument();
      const testingDOMParent = doc.getElementById(TESTING_PARENT_ID) || doc.body;
      const bannerDOMParent = testing ? testingDOMParent : doc.body;
      const privacyBannerDOMElement = doc.getElementById(BANNER_ELEMENT_ID);
      privacyBannerDOMElement.style.display = 'none';
      if (bannerType === TOP) {
        bannerDOMParent.style.paddingTop = this.oldPadding;
      }
    };
  }
  displayBanner() {
    if (!this.hasRendered()) {
      this.render();
      return;
    }
    const {
      context
    } = this.privacyBanner;
    const {
      bannerType,
      testing
    } = this.privacySettings;
    const doc = context.getDocument();
    const testingDOMParent = doc.getElementById(TESTING_PARENT_ID) || doc.body;
    const bannerDOMParent = testing ? testingDOMParent : doc.body;
    const privacyBannerDOMElement = doc.getElementById(BANNER_ELEMENT_ID);
    privacyBannerDOMElement.style.display = '';
    if (bannerType === TOP) {
      bannerDOMParent.style.paddingTop = privacyBannerDOMElement.offsetHeight;
    }
  }
  displayModal() {
    const {
      context
    } = this.privacyBanner;
    const {
      testing
    } = this.privacySettings;
    const doc = context.getDocument();
    const testingDOMParent = doc.getElementById(TESTING_PARENT_ID) || doc.body;
    const bannerDOMParent = testing ? testingDOMParent : doc.body;
    if (!this.modalTemplate.hasRendered()) {
      this.modalTemplate.render(bannerDOMParent, this.privacySettings, this.getHideBannerFn());
    } else {
      this.modalTemplate.displayModal();
    }
  }
  render() {
    const {
      context
    } = this.privacyBanner;
    const {
      accentColor,
      bannerType,
      testing
    } = this.privacySettings;
    if (getIsBannerPopupDisallowed(context)) {
      return;
    }
    if (this.hasRendered()) {
      return;
    }
    let extraClassName = '';
    let styleContent = standardStyledContent;
    if (bannerType) {
      extraClassName = bannerType === BOTTOM ? 'hs-cookie-notification-position-bottom' : '';
    }
    if (accentColor) {
      const isValidAccentColor = /^#[0-9A-Fa-f]{3,6}$/.test(accentColor);
      styleContent = isValidAccentColor ? customizableStyledContent.replace(/#425b76/g, accentColor) : customizableStyledContent;
    }
    const doc = context.getDocument();
    const testingDOMParent = doc.getElementById(TESTING_PARENT_ID) || doc.body;
    const bannerDOMParent = testing ? testingDOMParent : doc.body;
    const styleTag = doc.createElement('style');
    styleTag.setAttribute('type', 'text/css');
    if (styleTag.styleSheet) {
      styleTag.styleSheet.cssText = styleContent;
    } else {
      const textTag = doc.createTextNode(styleContent);
      styleTag.appendChild(textTag);
    }
    const firstBodyElement = bannerDOMParent.childNodes[0];
    bannerDOMParent.insertBefore(styleTag, firstBodyElement);
    const bannerContent = getHtmlContent(this.privacySettings, extraClassName);
    bannerDOMParent.insertBefore(createHtmlElement(bannerContent), firstBodyElement);
    const privacyBannerDOMElement = doc.getElementById(BANNER_ELEMENT_ID);
    if (!privacyBannerDOMElement) {
      return;
    }
    if (bannerType === TOP) {
      bannerDOMParent.style.paddingTop = privacyBannerDOMElement.offsetHeight;
    }
    addAcceptListener(this.privacySettings, privacyBannerDOMElement, this.privacyBanner, this.getHideBannerFn());
    addDeclineListener(this.privacySettings, privacyBannerDOMElement, this.privacyBanner, this.getHideBannerFn());
    addCookieSettingsListener(this.privacyBanner, this.privacySettings, bannerDOMParent, this.modalTemplate, this.getHideBannerFn());
    addCloseButtonListener(this.privacySettings, this.privacyBanner, this.getHideBannerFn());
  }
}